import {
  EDUCATION_MATERIAL_STORE_KEY,
} from '../components/inboxAndDocs/inboxAndDocs.constants';

function goToSelectedFolder({
  folderId = 0,
  folderContent = [],
  breadcrumbs = null,
}) {
  let selectedFolder = folderContent
    .find((folder) => String(folder.Id) === String(folderId));

  if (!selectedFolder) {
    // TODO: Remove 'Childrens' validation when v2 is complete
    const foldersChildrenMtx = folderContent
      .map((folders) => folders?.Childrens || folders?.Folders)
      .filter((child) => child?.length);
    const flatFoldersChildren = foldersChildrenMtx
      .reduce((inputArray, flatArray = []) => inputArray.concat(flatArray));

    selectedFolder = flatFoldersChildren
      .find((item) => String(item.Id) === String(folderId));
  }

  breadcrumbs.onDirectNavigation({
    id: selectedFolder.Id,
    name: selectedFolder.Name,
  });
}

/**
 * Find folder content (folders or files) by folderId in the provided list.
 * @param {*} list list to look for the folderId.
 * @param {*} folderId folder id content to look for.
 * @returns
 */
const findFolderContentById = ({ list, folderId }) => list
  .reduce((found, item) => {
    // found previously in the loop
    if (found) {
      return found;
    }

    // found exactly the folder or file
    if (String(item.Id) === String(folderId)) {
      return item;
    }

    // may contain folders or files inside
    const nestedContent = item.Metadata?.Folders || item.Metadata?.Files;

    // if still there are nested folders or files,
    // look for the folderId inside them
    if (nestedContent?.length) {
      return findFolderContentById({ folderId, list: nestedContent });
    }

    // no results found
    return null;
  }, null);

/**
 * Get education material content (folders or files) from local storage.
 * If the content is not in local storage or folderId is
 * not provided, it returns null.
 * @param {*} folderId folder id content to look for.
 * @returns
 */
const getEducationMaterialFolderContent = (folderId) => {
  const educationMaterialContent = JSON.parse(localStorage
    .getItem(EDUCATION_MATERIAL_STORE_KEY));

  // no education material found in local storage or folderId not provided
  if (!educationMaterialContent || !folderId) {
    return null;
  }

  // find the folder content within the education material content
  const folderContent = findFolderContentById({
    folderId,
    list: educationMaterialContent,
  });

  // folder content may contain any of these: folders or files
  if (folderContent && folderContent.Metadata) {
    return folderContent.Metadata.Folders || folderContent.Metadata.Files;
  }

  // no content found
  return null;
};

/**
 * Check whether a file (by its Id) belongs to the education material
 * tree stored in local storage.
 * @param {string|number} fileId file id to look for.
 * @returns {boolean}
 */
const isEducationMaterialFile = (fileId) => {
  const educationMaterialContent = JSON.parse(
    localStorage.getItem(EDUCATION_MATERIAL_STORE_KEY),
  );

  if (!educationMaterialContent || !fileId) {
    return false;
  }

  return !!findFolderContentById({
    folderId: fileId,
    list: educationMaterialContent,
  });
};

export {
  getEducationMaterialFolderContent,
  goToSelectedFolder,
  isEducationMaterialFile,
};
